// extracted by mini-css-extract-plugin
export default {"file_size":"file-size-label_file_size__sdPVr"};